var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-upload"},[_c('userHeader'),_vm._t("default"),_c('userFooter')],2)}
var staticRenderFns = []

export { render, staticRenderFns }